export enum RejectType {
  REJECT = 'REJECT',
  WASTE = 'WASTE'
}
